import { Rate } from "antd";
import { useGeneralInfo } from "./modules/useGeneralInfo";

function GeneralInfoTemplate() {
  const {
    hotelInfo,
    updateHotelInfo,
    message,
    discardChanges,
    handleChange,
    handleRateChange,
    handleSocialMediaChange,
    handleFileChange,
  } = useGeneralInfo();

  return (
    <div className="container">
      <h1>Manage Hotel Information</h1>
      {message && <p>{message}</p>}

      <form className="row">
        <div className="col-md-6">
          <label className="mt-2">
            <strong>Hotel Name:</strong>
          </label>
          <input
            type="text"
            name="hotelName"
            value={hotelInfo.hotelName}
            onChange={handleChange}
            className="form-control"
          />

          <label className="mt-2">
            <strong>Hotel Description:</strong>
          </label>
          <textarea
            name="description"
            value={hotelInfo.description}
            onChange={handleChange}
            className="form-control"
            maxLength="500"
            placeholder="Enter a short description for SEO and social media sharing."
          ></textarea>

          <label className="mt-2">
            <strong>Email:</strong>
          </label>
          <input
            type="email"
            name="email"
            value={hotelInfo.email}
            onChange={handleChange}
            className="form-control"
          />

          <label className="mt-2">
            <strong>Phone Number:</strong>
          </label>
          <input
            type="tel"
            name="phoneNumber"
            value={hotelInfo.phoneNumber}
            onChange={handleChange}
            className="form-control"
          />

          <label className="mt-2">
            <strong>Address:</strong>
          </label>
          <input
            type="text"
            name="address"
            value={hotelInfo.address}
            onChange={handleChange}
            className="form-control"
          />

          <label className="mt-2">
            <strong>Map Location (URL):</strong>
          </label>
          <input
            type="url"
            name="mapLocation"
            value={hotelInfo.mapLocation}
            onChange={handleChange}
            className="form-control"
          />

          <label className="mt-2">
            <strong>Social Media Links:</strong>
          </label>
          <input
            type="url"
            name="facebook"
            placeholder="Facebook URL"
            value={hotelInfo?.socialMediaLinks?.facebook}
            onChange={handleSocialMediaChange}
            className="form-control"
          />
          <input
            type="url"
            name="instagram"
            placeholder="Instagram URL"
            value={hotelInfo?.socialMediaLinks?.instagram}
            onChange={handleSocialMediaChange}
            className="form-control"
          />
          <input
            type="url"
            name="tripadvisor"
            placeholder="Tripadvisor URL"
            value={hotelInfo?.socialMediaLinks?.tripadvisor}
            onChange={handleSocialMediaChange}
            className="form-control"
          />
          <input
            type="url"
            name="officialWebsite"
            placeholder="Official Website URL"
            value={hotelInfo?.socialMediaLinks?.officialWebsite}
            onChange={handleSocialMediaChange}
            className="form-control"
          />
        </div>

        <div className="col-md-6">
          <label className="mt-2">
            <strong>Star Rating:</strong>
          </label>
          <br />
          <Rate
            value={hotelInfo.starRating}
            onChange={handleRateChange}
            allowHalf
            className="mb-2 mt-2"
          />
          <br />

          <label className="mt-2">
            <strong>Factsheet (PDF):</strong>
          </label>
          <input
            type="file"
            name="factsheet"
            onChange={handleFileChange}
            className="form-control"
          />

          <label className="mt-2">
            <strong>Feature Image (for social media and SEO):</strong>
          </label>
          {hotelInfo.featureImage && (
            <div>
              <img
                src={hotelInfo.featureImage}
                alt="Current Feature"
                style={{ maxWidth: "100px", margin: "10px 0" }}
              />
            </div>
          )}
          <input
            type="file"
            name="featureImage"
            onChange={handleFileChange}
            className="form-control"
          />

          <label className="mt-2">
            <strong>Hotel Logo (PNG only):</strong>
          </label>
          {hotelInfo.logo && (
            <div>
              <img
                src={hotelInfo.logo}
                alt="Current Logo"
                style={{ maxWidth: "100px", margin: "10px 0" }}
              />
            </div>
          )}
          <input
            type="file"
            name="logo"
            accept="image/png"
            onChange={handleFileChange}
            className="form-control"
          />

          <label className="mt-2">
            <strong>Hotel Favicon (PNG only, square):</strong>
          </label>
          {hotelInfo.favicon && (
            <div>
              <img
                src={hotelInfo.favicon}
                alt="Current Favicon"
                style={{ maxWidth: "32px", margin: "10px 0" }}
              />
            </div>
          )}
          <input
            type="file"
            name="favicon"
            accept="image/png"
            onChange={handleFileChange}
            className="form-control"
          />

          <label className="mt-2">
            <strong>Currency:</strong>
          </label>
          <select
            name="currency"
            value={hotelInfo.currency}
            onChange={handleChange}
            className="form-control"
          >
            <option value="USD">USD</option>
            <option value="EUR">EUR</option>
          </select>

          <label className="mt-2">
            <strong>Preferred Language:</strong>
          </label>
          <select
            name="preferredLanguage"
            value={hotelInfo.preferredLanguage}
            onChange={handleChange}
            className="form-control"
          >
            <option value="English">English</option>
            <option value="Spanish">Spanish</option>
          </select>
        </div>

        <div className="col-12 d-flex justify-content-end mt-3">
          <button
            type="button"
            onClick={updateHotelInfo}
            className="btn btn-primary me-2"
          >
            Update
          </button>
          <button
            type="button"
            onClick={discardChanges}
            className="btn btn-secondary"
          >
            Discard Changes
          </button>
        </div>
      </form>
    </div>
  );
}

export default GeneralInfoTemplate;
